import React from "react"
import { Box } from "@mui/material"
import { AppFormDrawer, AppFormGrid, AppFormSection } from "@components"
import {
	autoEuropeSeasonSetsDrawerData,
	autoEuropeSeasonSetsIsSubmitting,
	clearAutoEuropeSeasonSetsSignals,
	isAutoEuropeSeasonSetsDrawerOpen,
} from "Pages/AutoEuropeTool/SeasonSets/@signals"
import AutoEuropeSeasonSetsFooter from "Pages/AutoEuropeTool/SeasonSets/@components/Footer"
import AutoEuropeSeasonSetsNameField from "Pages/AutoEuropeTool/SeasonSets/@components/NameField"
import AutoEuropeSeasonSetsRangesField from "Pages/AutoEuropeTool/SeasonSets/@components/SeasonRangesField"

export default function AutoEuropeSeasonSetsDrawer({ onSubmit }) {
	const isEditing = !!autoEuropeSeasonSetsDrawerData.peek().id

	return <AppFormDrawer
		icon="calendar-days"
		title={isEditing ? autoEuropeSeasonSetsDrawerData.peek().name : "Create Season Set"}
		width="40%"
		variant="persistent"
		isOpen={isAutoEuropeSeasonSetsDrawerOpen.value}
		controller={clearAutoEuropeSeasonSetsSignals}
		footer={
			<AutoEuropeSeasonSetsFooter
				onSubmit={() => onSubmit(autoEuropeSeasonSetsDrawerData.peek())}
				isLoading={autoEuropeSeasonSetsIsSubmitting.value}
			/>
		}
	>
		<AppFormSection icon="tag" title="General">
			<AppFormGrid>
				<Box sx={{ gridColumn: 'span 12' }}><AutoEuropeSeasonSetsNameField/></Box>
			</AppFormGrid>
		</AppFormSection>
		<AppFormSection icon="calendar-days" title="Seasons">
			<AppFormGrid>
				<Box sx={{ gridColumn: 'span 12' }}><AutoEuropeSeasonSetsRangesField/></Box>
			</AppFormGrid>
		</AppFormSection>
	</AppFormDrawer>
}
